async function responseSuccess({getState, dispatch, getSourceAction}, req) {
    if (req.data && req.data && req.data._reload) {
        window.location.reload();
    }
    return req;
}

export default {
    response: {
        success: responseSuccess
    }
}